import Swiper from 'swiper/bundle';

// PC only
let swiperSlide, swiperBool;
const breakPoint = 600;

window.addEventListener('load', () => {
  if (breakPoint > window.innerWidth) {
    swiperBool = false;
  } else {
    createSwiper();
    swiperBool = true;
  }
}, false);

window.addEventListener('resize', () => {
  if (breakPoint > window.innerWidth && swiperBool) {
    // SP
    swiper.destroy(false, true);
    swiperBool = false;
  } else if (breakPoint <= window.innerWidth && !(swiperBool)) {
    // PC
    createSwiper();
    swiperBool = true;
  }
}, false);

document.body.addEventListener('loadMore',function(){
  if (breakPoint > window.innerWidth) {
    // SP
    swiper.destroy(false, true);
  } else if (breakPoint <= window.innerWidth) {
    // PC
    createSwiper();
  }
});

document.body.addEventListener('rtCalled',function(){
  if (breakPoint > window.innerWidth) {
    // SP
    swiper.destroy(false, true);
  } else if (breakPoint <= window.innerWidth) {
    // PC
    createSwiper();
  }
});

function createSwiper() {
  swiperSlide = new Swiper(".swiper.m-slide:not(.swiper-initialized)", {
    loop: false,
    spaceBetween: 0,
    centeredSlides: true,
    grabCursor: true,
    centeredSlides: false,
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    loopFillGroupWithBlank: true,
    variableWidth: true,
    watchOverflow: true,
    // ページネーションが必要なら追加
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // ナビボタンが必要なら追加
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
}
